import { useApi, type ToolConfig } from '@/lib/api';

const CATALOG: Array<{ id: string; name: string; description: string }> = [
  { id: 'builtin.escalate_to_human', name: 'escalate_to_human', description: 'Stop autonomous replies and hand off to a human.' },
  { id: 'builtin.tag_ticket',        name: 'tag_ticket',        description: 'Attach tags like "vip" or "refund-request".' },
  { id: 'builtin.set_priority',      name: 'set_priority',      description: 'Set low / normal / high / urgent.' },
  { id: 'builtin.set_category',      name: 'set_category',      description: 'Classify: billing / bug / how-to / …' },
  { id: 'builtin.mark_spam',         name: 'mark_spam',         description: 'Flag the ticket as spam; stop replying.' },
  { id: 'builtin.mark_resolved',     name: 'mark_resolved',     description: 'Mark resolved after final reply sent.' },
];

export function BuiltInTools(props: {
  orgId: string;
  tools: ToolConfig[];
  onChanged: () => void;
}) {
  const api = useApi();
  const enabledMap = new Map(props.tools.map((t) => [t.tool_id, t]));

  const toggle = async (id: string, enable: boolean) => {
    await api.post(`/api/orgs/${props.orgId}/tools/enable`, {
      toolId: id,
      source: 'builtin',
      enabled: enable,
      needsApproval: Boolean(enabledMap.get(id)?.needs_approval),
    });
    props.onChanged();
  };

  const setApproval = async (id: string, needs: boolean) => {
    await api.post(`/api/orgs/${props.orgId}/tools/enable`, {
      toolId: id,
      source: 'builtin',
      enabled: Boolean(enabledMap.get(id)?.enabled),
      needsApproval: needs,
    });
    props.onChanged();
  };

  return (
    <div className="max-w-3xl">
      <p className="text-sm text-muted-foreground mb-4">
        Built-in tools act on the ticket itself. Toggle which ones your AI agent is allowed to call.
      </p>
      <ul className="space-y-2">
        {CATALOG.map((t) => {
          const cfg = enabledMap.get(t.id);
          const enabled = Boolean(cfg?.enabled);
          return (
            <li key={t.id} className="card p-4 flex items-center justify-between gap-4">
              <div>
                <div className="font-mono text-sm">{t.name}</div>
                <p className="text-sm text-muted-foreground">{t.description}</p>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <label className="flex items-center gap-1 text-xs">
                  <input
                    type="checkbox"
                    checked={Boolean(cfg?.needs_approval)}
                    onChange={(e) => setApproval(t.id, e.target.checked)}
                    disabled={!enabled}
                  />
                  needs approval
                </label>
                <label className="flex items-center gap-1 text-xs">
                  <input
                    type="checkbox"
                    checked={enabled}
                    onChange={(e) => toggle(t.id, e.target.checked)}
                  />
                  enabled
                </label>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
